import { ConfiguredPrice, PrimaryPriceType, InternalDisplayConfig } from "shared/src/types/ArticleCardProps";
import { PriceAndPromotionInfo } from "shared/src/types/PriceAndPromotionInfo";
import { includeMarginTaxesInPrice, primaryIsGross } from "shared/src/utils/PriceDisplayFramework";

export function primaryIsNet(primaryPriceType: PrimaryPriceType, configuredPrimaryPrice: ConfiguredPrice): boolean {
    return !primaryIsGross(primaryPriceType, configuredPrimaryPrice);
}
export function getPositionDisplayPrice(
    loadedPrice: PriceAndPromotionInfo | null | undefined,
    internalDisplayConfig: InternalDisplayConfig | null
): number | null | undefined {
    if (!loadedPrice) {
        return loadedPrice;
    }
    const isGross = primaryIsGross(null, internalDisplayConfig?.primaryPriceType);
    const includeTaxes = includeMarginTaxesInPrice(internalDisplayConfig);
    if (!includeTaxes) {
        if (!isGross) {
            return loadedPrice.positionNet;
        } else {
            return loadedPrice.positionGross;
        }
    } else {
        if (!isGross) {
            return loadedPrice.positionNetWithTaxes;
        } else {
            return loadedPrice.positionGrossWithTaxes;
        }
    }
}

export function getRelativePathForRedirectAfterLogin(location: { [x: string]: any }) {
    return "/login" + location?.pathname;
}
